import { Location, UserProfile as UserProfileSharedType, ApplicationType } from '@trnsact/trnsact-shared-types';
import { SelectOption } from 'global';
import { UserProfile } from 'types';
import { vendorContactRoleHumanReadable, vendorSalesGroupSubsetContactRole } from 'utils';

const getUserRolesSelectOptions = (): SelectOption[] =>
  Object.keys(vendorContactRoleHumanReadable).map(key => ({
    label: vendorContactRoleHumanReadable[key as keyof typeof vendorContactRoleHumanReadable],
    value: key,
  }));

const getUserRolesSubSetSelectOptions = (): SelectOption[] =>
  Object.keys(vendorSalesGroupSubsetContactRole).map(key => ({
    label: vendorSalesGroupSubsetContactRole[key as keyof typeof vendorSalesGroupSubsetContactRole],
    value: key,
  }));

const getUsersSelectOptions = (users: UserProfileSharedType[] | UserProfile[]): SelectOption[] =>
  users.map(user => ({ label: user.fullName!, value: user.id }));

const getLocationsSelectOptions = (locations: Location[]): SelectOption[] =>
  locations.map(location => ({ label: location.locationName!, value: location.locationId! }));

function convertEnumToSelectOptions<Value extends string, T extends Record<string, unknown>>(
  enumValue: T,
  options: { useKeyAsValue: boolean } = { useKeyAsValue: false }
): SelectOption<Value>[] {
  function formatKey(key: string): string {
    const withSpaces = key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[-_]/g, ' ');

    return withSpaces
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  return Object.entries(enumValue).map(([key, value]) => ({
    label: formatKey(key),
    value: options.useKeyAsValue ? (key as Value) : (value as Value),
  }));
}

function convertEnumValuesToSelectOptions<Value extends string, T extends Record<string, any>>(
  enumValue: T
): SelectOption<Value>[] {
  return Object.values(enumValue).map(value => ({
    label: value?.toString(),
    value: value as Value,
  }));
}

const getApplicationTypeOptions = [ApplicationType.Commercial, ApplicationType.Individual].map(v => ({
  value: v,
  label: v.charAt(0) + v.slice(1).toLowerCase(),
})) as SelectOption[];

export {
  convertEnumValuesToSelectOptions,
  getUserRolesSelectOptions,
  getUsersSelectOptions,
  getLocationsSelectOptions,
  getUserRolesSubSetSelectOptions,
  convertEnumToSelectOptions,
  getApplicationTypeOptions,
};
